import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import TaggedButton from '../../../components/TaggedButton';

interface HeaderContentOwnProps{
  collapsed:boolean
  toggleCollapsed:(value:boolean)=>void
}

const HeaderContent = (props:HeaderContentOwnProps) => {
  const { collapsed, toggleCollapsed } = props;

  return (
    <div>
      <TaggedButton
        tag="collapseMenu"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={() => toggleCollapsed(!collapsed)}
      />
    </div>
  );
};

export default HeaderContent;
